var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-icon btn-circle",attrs:{"variant":"warning"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-undo icon-nm",attrs:{"size":"18"}})])}
var staticRenderFns = []

export { render, staticRenderFns }